<script setup lang="ts">
import { useFormStore } from "@stores/form.store"
import { TRACKING_EVENTS } from "@constant"
import { TrackingPlugin } from "@plugins/tracking.plugin"
import { inject, onActivated, onDeactivated, ref } from "vue"

const { snapshot } = useFormStore()

const { $track } = inject<TrackingPlugin>("tracking")!

const timeCompletion = ref(new Date().getTime())

onActivated(() => {
    timeCompletion.value = new Date().getTime()
    $track(TRACKING_EVENTS.STEP_ENTERED, {
        step: snapshot.value.context.step + 1,
        formId: "",
    })
})

onDeactivated(() => {
    $track(TRACKING_EVENTS.STEP_COMPLETED, {
        step: snapshot.value.context.step + 1,
        timeCompletion: (
            (new Date().getTime() - timeCompletion.value) /
            1000
        ).toFixed(1),
    })
})
</script>

<template>
    <KeepAlive class="step-two">
        <FormTypeLogement
            v-if="snapshot.matches({ Step2: 'FormTypeLogement' })"
        />
        <FormInfoLogementGeneral
            v-else-if="snapshot.matches({ Step2: 'FormInfoLogementGeneral' })"
        />
        <FormTypeEnergy
            v-else-if="snapshot.matches({ Step2: 'FormTypeEnergy' })"
        />
        <FormEnergyElec
            v-else-if="snapshot.matches({ Step2: 'FormEnergyElec' })"
        />
        <FormGaz v-else-if="snapshot.matches({ Step2: 'FormGaz' })" />
        <FormEnergyGaz
            v-else-if="snapshot.matches({ Step2: 'FormEnergyGaz' })"
        />
        <FormInvalid
            v-else-if="snapshot.matches({ Step2: 'FormInvalid' })"
        ></FormInvalid>
    </KeepAlive>
</template>
